export default function getValueFromHierarchy(formData, keyOrder) {
  let currentObj = formData;
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keyOrder) {
    currentObj = currentObj[key];
  }
  return currentObj;
}
